import { useState, useEffect, useMemo } from 'react';
import CardLayout from '../../../components/utils/CardLayout';
import { useDispatch, useSelector } from 'react-redux';
import portinActivationAction from '../../../redux/portinActivation/actions'
import Button from '../../../components/utils/Button'
import Table from '../../../components/utils/Table';
import SideButtons from '../../../components/utils/SideButtons';
import Alert from '../../../components/utils/Alert';
import SearchBar from '../../../components/utils/SearchBar';
import { convertDateTimeToRequiredFormatTZ, isAdmin, isAdminAgent, isDealer } from '../../../helpers/commonFunction';
import Tag from '../../../components/utils/Tag'
import DownloadCloud2sLineIcon from 'remixicon-react/DownloadCloud2LineIcon';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import Modal from '../../../components/utils/Model'
import EyeFill from 'remixicon-react/EyeFillIcon';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AddPortinActivation from './AddPortinActivation';
import authActions from '../../../redux/auth/actions';
import EditCircleLineIcon from 'remixicon-react/EditCircleLineIcon';
import ManualPortinUpdate from './ManualPortinUpdate';
import DataTable from '../../../components/utils/DataTable';

const { getBulkPortinActivationList, getBulkPortinActivationListByBatchID, openAddPortinModal, updatePortinActivationBulkStatus, updatePortinStatus, resetMessage, resetSucessMessage, getPortinActivations } = portinActivationAction;
const { getUserDataByToken } = authActions;

const PortinActivation = () => {
    const dispatch = useDispatch();
    const { bulkPortinActivationRequestResult, bulkPortinActivationResultByBatchID, bulkPortinActivationResultByBatchIDLoading, createPortinActivationMessage, updatePortinStatusMessage, updatePortinStatusError, updateManualPortinActivationMessage, getPortinActivationsList, getPortinActivationsTotalRows, getPortinActivationsLoading } = useSelector((state) => state.portinActivation);
    const { tokenData } = useSelector((state) => state.auth);
    const [filterText, setFilterText] = useState("");
    const [openViewModel, setOpenViewModel] = useState(false);
    const [selectedBatchID, setSelectedBatchID] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [portinUpdateLoading, setPortinUpdateLoading] = useState(null);
    const [selectedBatchData, setSelectedBatchData] = useState(null);
    const [manualUpdateFlag, setManualUpdateFlag] = useState(false);
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDirection, setSortDirection] = useState("desc");
    const [search, setSearch] = useState("");

    useEffect(() => {
        dispatch(getBulkPortinActivationList());
        dispatch(resetSucessMessage())
    }, []);

    useEffect(() => {
        if (createPortinActivationMessage !== null && createPortinActivationMessage !== undefined) {
            displayAlert(createPortinActivationMessage, 'alert-success');
            dispatch(resetMessage());
            dispatch(getUserDataByToken());
        }
        if (updatePortinStatusError !== null && updatePortinStatusError !== undefined) {
            displayAlert(updatePortinStatusError, 'alert-danger');
            setPortinUpdateLoading("")
            dispatch(getUserDataByToken());
        }
        if (updatePortinStatusMessage !== null && updatePortinStatusMessage !== undefined) {
            displayAlert(updatePortinStatusMessage, 'alert-success');
            dispatch(getUserDataByToken());
        }
        if (updateManualPortinActivationMessage !== null && updateManualPortinActivationMessage !== undefined) {
            displayAlert(updateManualPortinActivationMessage, 'alert-success');
            setManualUpdateFlag(false);
            dispatch(resetSucessMessage())
            dispatch(getUserDataByToken());
        }
    }, [createPortinActivationMessage, updatePortinStatusError, updatePortinStatusMessage, updateManualPortinActivationMessage]);

    const handleFilterChange = (value) => {
        setFilterText(value);
        setSearch(value);
    };

    const handleShowTransactionDetails = (item) => {
        alertCancel();
        setOpenViewModel(true);
        const batchID = item.bulktransactionid;
        setSelectedBatchID(batchID);
        const newData = {
            batchID: batchID,
        };
        setSelectedBatchData(newData)
        dispatch(getBulkPortinActivationListByBatchID(newData));
    };

    //Modal Column
    const ModalColumns = [
        { displayName: '#', key: 'key' },
        { displayName: 'ACTION', key: 'action' },
        { displayName: 'TRANSACTIONID', key: 'transactionID' },
        { displayName: 'SERIAL NUMBER', key: 'serialNumber' },
        // { displayName: 'IMEI', key: 'imeiNumber' },
        ...(bulkPortinActivationResultByBatchID?.some(x => x.NetworkID == 10)
            ? [{ displayName: 'IMEI', key: 'imeiNumber' }]
            : []
        ),
        { displayName: 'PHONE NUMBER', key: 'mobileNumber' },
        { displayName: 'PIN', key: 'pin' },
        { displayName: 'ACCOUNT NUMBER', key: 'accountNumber' },
        { displayName: 'AREA CODE', key: 'zipCode' },
        { displayName: 'NETWORK', key: 'networkName' },
        { displayName: 'AMOUNT', key: 'amountCharged' },
        { displayName: 'DEALER NAME', key: 'dealerName' },
        { displayName: 'STATUS', key: 'status' },
        { displayName: 'SUBMITTED DATE', key: 'requestedDtTm' },
        { displayName: 'REMARK', key: 'remark' },
    ];

    //Table Data
    const filteredItems = Array.isArray(bulkPortinActivationRequestResult) && bulkPortinActivationRequestResult.length > 0 ? bulkPortinActivationRequestResult.filter(item => {
        if (typeof filterText !== 'string' || typeof item !== 'object') return false;

        const statusText = (() => {
            const totalProcessed = item.TotalProcessed || 0;
            const totalCancelled = item.TotalCancelled || 0;
            const totalQuantity = item.Quantity || 0;

            if (totalProcessed === totalQuantity) return 'completed';
            if (totalCancelled === totalQuantity) return 'failed';
            if (totalProcessed + totalCancelled === totalQuantity) return 'partial';
            return 'pending';
        })();

        return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase())) || statusText.includes(filterText.toLowerCase());
    }) : [];

    //Model Data
    const dataSource = bulkPortinActivationResultByBatchID && bulkPortinActivationResultByBatchID.length > 0 && bulkPortinActivationResultByBatchID.map((Item, key) => {
        return {
            key: key + 1,
            transactionID: Item.TransactionID,
            serialNumber: Item.SerialNumber,
            accountNumber: Item.AccountNumber,
            mobileNumber: Item.MSISDN,
            zipCode: Item.AreaCode,
            pin: Item.PIN,
            networkName: Item.NetworkName,
            dealerName: Item.DealerName,
            amountCharged: Item.AmountCharged ? '$' + parseFloat(Item.AmountCharged).toFixed(2) : '',
            requestedDtTm: Item.RequestedDtTm !== null ? convertDateTimeToRequiredFormatTZ(Item.RequestedDtTm) : '',
            status: < Tag color={Item.RequestStatus === 13 ? 'badge-danger' : Item.RequestStatus === 11 ? 'badge-warning' : Item.RequestStatus === 12 ? 'badge-success' : Item.RequestStatus === 32 ? 'badge-secondary' : Item.RequestStatus === 49 ? 'badge-info' : 'badge-secondary'} title={Item.StatusDescription} />,
            remark: Item.Remark,
            imeiNumber: Item.IMEI,
            action: (
                Item.CustomerSupport === 0 && Item.RequestStatus == 11 ? (portinUpdateLoading === Item.ID ? (
                    <div className="spinner-border text-secondary" role="status"> <span className="sr-only">Loading...</span> </div>
                ) : (
                    <div className="icon iq-action-icon-box rounded-circle bg-info" onClick={() => handleOpenStatusModal(Item.ID, Item.SerialNumber, Item.AggregatorID)} style={{ cursor: 'pointer' }} >
                        <i className="ri-refresh-line"></i>
                    </div>
                )
                ) : null
            )
        }
    });

    const listDataModel = bulkPortinActivationResultByBatchID.map((item, key) => ({
        'Sr. No': key + 1,
        'Transaction ID': item.TransactionID,
        'Serial Number': item.SerialNumber,
        'IMEI': item.IMEI,
        'Account Number': item.AccountNumber,
        'Phone Number': item.MSISDN,
        'Area Code': item.AreaCode,
        'PIN': item.PIN,
        'Network': item.NetworkName,
        'Amount': item.AmountCharged,
        'Dealer Name': item.DealerName,
        'Submitted Date': convertDateTimeToRequiredFormatTZ(item.RequestedDtTm),
        'Status': item.StatusDescription,
        'Remark': item.Remark,
    }));

    const exportToCSVModal = async () => {
        if (listDataModel && listDataModel.length > 0) {
            const ws = XLSX.utils.json_to_sheet(listDataModel);
            const wb = { Sheets: { 'bulkPortinActivationList': ws }, SheetNames: ['bulkPortinActivationList'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            await FileSaver.saveAs(data, 'Portin_Activation_Report' + fileExtension);
        }
    }

    const handleCopy = () => {
        const data = bulkPortinActivationResultByBatchID || [];
        if (data.length === 0) {
            toast.error('No data to copy!');
            return;
        }

        const header = ['Phone Number', 'Account Number', 'PIN', 'Area Code'];

        const rows = data.map(item => [
            item.MSISDN?.toString().trim() || '',
            item.AccountNumber?.toString().trim() || '',
            item.PIN?.toString().trim() || '',
            item.AreaCode?.toString().trim() || ''
        ]);

        const allRows = [header, ...rows];

        const colWidths = allRows[0].map((_, colIndex) =>
            Math.max(...allRows.map(row => row[colIndex].length))
        );

        const textToCopy = allRows
            .map(row => row.map((cell, i) => cell.padEnd(colWidths[i], ' ')).join('   '))
            .join('\n');

        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                toast.success('Number details copied to Clipboard', {
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            })
            .catch(err => {
                toast.error('Failed to copy!');
                console.error('Failed to copy: ', err);
            });
    };

    const handleRefersh = () => {
        if (!selectedBatchID) return;
        const newData = {
            batchID: selectedBatchID,
        };
        dispatch(getBulkPortinActivationListByBatchID(newData));
        toast.success('Data refreshed successfully', {
            autoClose: 2000,
        });
    }

    const handleAddPortinActivation = () => {
        dispatch(openAddPortinModal())
    }

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
        dispatch(resetSucessMessage())
    }

    const handleOpenStatusModal = (activationId, serialNumber, aggregatorID) => {
        setPortinUpdateLoading(activationId);
        let req = {
            activationId: activationId,
            serialNumber: serialNumber,
            aggregatorID: aggregatorID,
        };
        dispatch(updatePortinStatus(req, selectedBatchData));
    }

    const handleManualUpdatePortin = () => {
        setManualUpdateFlag(true);
        alertCancel();
    }

    const renderManualPortinUpdate = () => {
        return <ManualPortinUpdate show={manualUpdateFlag} hide={() => setManualUpdateFlag(false)} />;
    }

    // SERVER SIDE PROCESSING
    const columns = [
        {
            name: "#",
            selector: row => row.id,
            sortable: true,
            sortField: "ID",
            width: '80px',
            center: true

        },
        {
            name: "REFERENCE",
            selector: row => row.reference,
            cell: (row) => (
                <div className="flex flex-col py-2">
                    <div>
                        <strong>Batch TXNID:</strong>{' '}
                        <span
                            onClick={() => handleShowTransactionDetails(row)}
                            style={{ cursor: 'pointer', color: '#990404', fontWeight: '600', textDecoration: 'underline', }}
                            title="view details"
                        >
                            {row.bulktransactionid || '-'}
                        </span>
                    </div>
                    <div className='my-2'><strong>Dealer Name:</strong> {row.dealername || '-'}</div>
                    <div><strong>Dealer Email:</strong> {row.contactemailid}</div>
                </div>
            ),
            width: '300px',
        },
        {
            name: "NETWORK",
            selector: row => row.network,
            width: '150px',
        },
        {
            name: "AREA CODE",
            selector: row => row.areacode,
            width: '150px',
        },
        {
            name: "QUANTITY",
            cell: (row) => (<>
                <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                    <Tag color="badge-success" title={`${row.totalprocessed}`}>
                    </Tag>
                    <Tag color="badge-danger" title={`${row.totalcancelled}`}>
                    </Tag>
                    <Tag color="badge-secondary" title={`${row.quantity}`}>
                    </Tag>
                </div>
            </>),
            width: '120px',
        },
        {
            name: "AMOUNT",
            selector: row => row.amount,
        },
        {
            name: "STATUS",
            cell: (row) => {
                const totalProcessed = row.totalprocessed || 0;
                const totalCancelled = row.totalcancelled || 0;
                const totalQuantity = row.quantity || 0;

                if (totalProcessed === totalQuantity) {
                    return <Tag color="badge-success" title="Completed" />;
                } else if (totalCancelled === totalQuantity) {
                    return <Tag color="badge-danger" title="Failed" />;
                } else if (totalProcessed + totalCancelled === totalQuantity) {
                    return <Tag color="badge-secondary" title="Partial" />;
                } else {
                    return <Tag color="badge-secondary" title="Partial" />;
                }
            }
        },
        {
            name: "SUBMITTED DATE",
            selector: row => row.submitteddate,
            width: '180px',
        },
        {
            name: "ACTION",
            selector: row => row.action,
            cell: (row) => (
                <Link to="#" onClick={() => handleShowTransactionDetails(row)} >
                    <span data-toggle="tooltip" data-placement="top" title="View">
                        <EyeFill size="1.2em" style={{ color: "#294c28eb" }} />
                    </span>
                </Link>
            )
        },
    ];

    const data = useMemo(() => {
        if (!getPortinActivationsList || getPortinActivationsList.length === 0) {
            return [];
        }
        return getPortinActivationsList.map((item, index) => ({
            id: ((page - 1) * perPage) + (index + 1),
            totalprocessed: item.TotalProcessed,
            totalcancelled: item.TotalCancelled,
            quantity: item.Quantity,
            bulktransactionid: item.BulkTransactionID,
            dealername: item.DealerName,
            contactemailid: item.ContactEmailID,
            reference: '',
            network: item.NetworkName,
            areacode: item.AreaCode,
            quantity: item.Quantity,
            amount: item.TotalAmount ? '$' + parseFloat(item.TotalAmount).toFixed(2) : '',
            status: '',
            submitteddate: item.RequestedDtTm !== null ? convertDateTimeToRequiredFormatTZ(item.RequestedDtTm) : '',
            action: ''
        }));
    }, [getPortinActivationsList]);

    useEffect(() => {
        const requestData = {
            page: page,
            perPage: perPage,
            search: search,
            sortColumn: sortColumn ?? 'id',
            sortDirection: sortDirection,
        };
        dispatch(getPortinActivations(requestData));
    }, [page, perPage, sortColumn, sortDirection, search, createPortinActivationMessage]);
    // END SERVER SIDE PROCESSING

    return (
        <CardLayout title="Portin Activation">
            <ToastContainer />
            {showAlert && !updatePortinStatusMessage && !updatePortinStatusError && <div className='mt-4'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
            {
                !manualUpdateFlag &&
                <div>
                    <div className="row mb-3  ">
                        <div className='col-lg-3  activation-request-search-btn mb-sm-444'>
                            <SearchBar onFilter={handleFilterChange} filterText={filterText} />
                        </div>
                        <div className='col-lg-9 d-flex justify-content-end activation-request-action-btn' style={{ gap: '5px' }}>
                            {isDealer(tokenData) && <>
                                <SideButtons title="Add Portin" onClick={handleAddPortinActivation} buttonStyle="primary" style={{ marginLeft: '8px' }} />
                            </>}
                            <div>
                                {(isAdmin(tokenData) || isAdminAgent(tokenData) || tokenData[0]?.IsAgent == 1) && (
                                    <Button title="Manual Portin Update" onClick={handleManualUpdatePortin} icon={<EditCircleLineIcon size={15} />} style="minWidth:120px" buttonClass={isAdmin(tokenData) ? `btn btn-primary mr-2 font-weight-bold text-white` : `btn btn-primary mr-2 font-weight-bold text-white`} />
                                )}
                            </div>
                        </div>
                    </div>
                    <DataTable
                        columns={columns}
                        data={data}
                        setPerPage={setPerPage}
                        setPage={setPage}
                        setSortColumn={setSortColumn}
                        setSortDirection={setSortDirection}
                        paginationTotalRows={getPortinActivationsTotalRows}
                        loading={getPortinActivationsLoading}
                        defaultSortField="#"
                        defaultSortAsc={false}
                        customStyles={{
                            headRow: {
                                style: {
                                    backgroundColor: '#FFF5F5'
                                },
                            },
                            headCells: {
                                style: {
                                    fontWeight: 'bold',
                                    fontSize: "14px"
                                },
                            },
                        }}
                    />
                </div>
            }

            <Modal
                showModal={openViewModel}
                title={"Portin Details : "}
                subTitle={<span style={{ color: '#990404' }}>{selectedBatchID}</span>}
                onHide={() => setOpenViewModel(false)}
                width={1000}
                showFooter={false}
            >
                {showAlert && <div className='mt-4'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
                <div className="d-flex justify-content-between mb-3">
                    <div>
                        <button onClick={handleCopy} style={{ minWidth: '100px', padding: '6px 10px', backgroundColor: '#990404', color: 'white', fontWeight: 'bold', border: 'none', borderRadius: '4px', cursor: 'pointer' }} > Copy </button>
                    </div>
                    <div className="d-flex" style={{ gap: '8px' }}>
                        {(isAdmin(tokenData) || isAdminAgent(tokenData) || tokenData[0]?.IsAgent == 1) && (
                            <div className="d-flex">
                            </div>
                        )}
                        {listDataModel && listDataModel.length > 0 && (
                            <Button onClick={exportToCSVModal} title="Export" icon={<DownloadCloud2sLineIcon size={15} />} style={{ minWidth: '120px' }} buttonClass="btn acti-export-btn-v acti-ex-btn font-weight-bold text-white" />
                        )}
                        <button onClick={handleRefersh} style={{ minWidth: '100px', padding: '6px 10px', backgroundColor: '#990404', color: 'white', fontWeight: 'bold', border: 'none', borderRadius: '4px', cursor: 'pointer' }} > Refresh </button>
                    </div>
                </div>

                <Table columns={ModalColumns} loading={bulkPortinActivationResultByBatchIDLoading} data={dataSource} pagination={false} />
            </Modal>

            <AddPortinActivation />
            {manualUpdateFlag && renderManualPortinUpdate()}

        </CardLayout>
    )
}

export default PortinActivation;